import { render, staticRenderFns } from "./CmgCountrySwitchAlertModal.vue?vue&type=template&id=6ef372cc&scoped=true&lang=pug&"
import script from "./cmg-country-switch-alert-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-country-switch-alert-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCountrySwitchAlertModal.vue?vue&type=style&index=0&id=6ef372cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef372cc",
  null
  
)

export default component.exports